export default __webpack_public_path__ + "static/media/logo_minimal.d144bc67.svg";